import * as React from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';
import DoorSlidingIcon from '@mui/icons-material/DoorSliding';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LineWeightIcon from '@mui/icons-material/LineWeight';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SummarizeIcon from '@mui/icons-material/Summarize';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import BadgeIcon from '@mui/icons-material/Badge';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import DiscountIcon from '@mui/icons-material/Discount';
import RamenDiningIcon from '@mui/icons-material/RamenDining';
import StraightenIcon from '@mui/icons-material/Straighten';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import LabelIcon from '@mui/icons-material/Label';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import BusinessIcon from '@mui/icons-material/Business';
import ScaleIcon from '@mui/icons-material/Scale';
import BackupIcon from '@mui/icons-material/Backup';
import BarChartIcon from '@mui/icons-material/BarChart';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import ApartmentIcon from '@mui/icons-material/Apartment';
import RepartitionIcon from '@mui/icons-material/Repartition';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PaidIcon from '@mui/icons-material/Paid';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ArticleIcon from '@mui/icons-material/Article';
import SendIcon from '@mui/icons-material/Send';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import AddCommentIcon from '@mui/icons-material/AddComment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import TuneIcon from '@mui/icons-material/Tune';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import HistoryIcon from '@mui/icons-material/History';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import WorkIcon from '@mui/icons-material/Work';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PaymentsIcon from '@mui/icons-material/Payments';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ContactsIcon from '@mui/icons-material/Contacts';


export default function Menu(props) {
  const { t } = useTranslation();
  const [openCategory, setOpenCategory] = React.useState(false);
  const [openSubCategory, setOpenSubCategory] = React.useState(false);
  const [openWarehouse, setOpenWarehouse] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [openCoupon, setOpenCoupon] = React.useState(false);
  const [openVendor, setOpenVendor] = React.useState(false);
  const [openSize, setOpenSize] = React.useState(false);
  const [openProduct, setOpenProduct] = React.useState(false);
  const [openReciving, setOpenReciving] = React.useState(false);
  const [openUom, setOpenUom] = React.useState(false);
  const [openRecipe, setOpenRecipe] = React.useState(false);
  const [openDeal, setOpenDeal] = React.useState(false);
  const [openRestaurant, setOpenRestaurant] = React.useState(false);
  // const [openMasterControl, setOpenMasterControl] = React.useState(false);
  const [openOrderBooking, setOpenOrderBooking] = React.useState(false);
  const [openPaymentReceiving, setPaymentReceiving] = React.useState(false);
  // const [openhall, setOpenhall] = React.useState(false);
  const [openIssuance, setOpenissuance] = React.useState(false);
  const [openDemand, setOpenDemand] = React.useState(false);
  const [openPurchase, setOpenPurchase] = React.useState(false);
  const [openBrand, setOpenBrand] = React.useState(false);
  const [openArea, setOpenArea] = React.useState(false);
  const [openShop, setOpenShop] = React.useState(false);
  const [openFlavour, setOpenFlavour] = React.useState(false);
  const [generateBarcode, setGenerateBarCode] = React.useState(false);
  const [openCustomer, setOpenCustomer] = React.useState(false);
  const [igp, setIgp] = React.useState(false);
  const [orderCreation, setOrderCreation] = React.useState(false);
  const [openExpenseType, setOpenExpenseType] = React.useState(false);
  const [division, setDivision] = React.useState(false);
  const [department, setDepartment] = React.useState(false);
  const [designation, setDesignation] = React.useState(false);
  const [shiftControl, setShiftControl] = React.useState(false);
  const [employeeType, setEmployeeType] = React.useState(false);
  const [employee, setEmployee] = React.useState(false);
  const [addSalary, setAddSalary] = React.useState(false);
  const [addIncrement, setAddIncrement] = React.useState(false);
  const [STAdvance, setSTAdvance] = React.useState(false);
  const [LTAdvance, setLTAdvance] = React.useState(false);
  const [fine, setFine] = React.useState(false);
  const [attendance, setAttendance] = React.useState(false);
  const [salary, setSalary] = React.useState(false);
  const [article, setArticle] = React.useState(false);
  const [costControl, setCostControl] = React.useState(false);
  const [productionIssuance, setProductionIssuance] = React.useState(false);
  const [productionReceiving, setProductionReceiving] = React.useState(false);
  const [openInvoice, setOpenInvoice] = React.useState(false);
  const [openLevelTwo, setOpenLevelTwo] = React.useState(false);
  const [openLevelThree, setOpenLevelThree] = React.useState(false);
  const [openLevelFour, setOpenLevelFour] = React.useState(false);
  const [openVoucher, setOpenVoucher] = React.useState(false);
  const [openTeamMember, setOpenTeamMember] = React.useState(false);
  const [openJob, setOpenJob] = React.useState(false);
  const [openConstructionOrder, setOpenConstructionOrder] = React.useState(false);
  const [openConstructionExpense, setOpenConstructionExpense] = React.useState(false);

  const [openFBRCompany, setOpenFBRCompany] = React.useState(false);
  const [openFBRProduct, setOpenFBRProduct] = React.useState(false);
  const [openFBRBuyer, setOpenFBRBuyer] = React.useState(false);



  const Checkpermissions = (permissionsType, permissionsName) => {
    return props.permissions.some(p => p[`${permissionsType}`] === permissionsName) ? true : false
  }
  const navLinkStyles = (isActive) => ({
    borderRadius: "12px",
    textDecoration: "none",
    width: "100%",
    display: "block",
    backgroundColor: isActive ? "#add8e6" : "transparent",
    color: isActive ? "black" : "#0445a5",
  });


  // { STORE LIST }
  let StoreList = <List>
    {/* WAREHOUSE */}
    {Checkpermissions("permissionsCatName", "Warehouse") &&
      <ListItemButton onClick={() => setOpenWarehouse(!openWarehouse)}>
        <ListItemIcon>
          <WarehouseIcon />
        </ListItemIcon>
        <ListItemText primary="Businnes Location" />
        {openWarehouse ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openWarehouse} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/warehouse/warehousAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Warehouse Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Businnes Location" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/warehouse/warehouseList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Warehouse List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Businnes Location List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* CATEGORY */}
    {Checkpermissions("permissionsCatName", "Category") &&
      <ListItemButton onClick={() => setOpenCategory(!openCategory)}>
        <ListItemIcon>
          <CategoryIcon />
        </ListItemIcon>
        <ListItemText primary="Category" />
        {openCategory ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCategory} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/catagory/addcatagory" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Category" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/catagory/listcatagory" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Category List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/*SUB CATEGORY */}
    {Checkpermissions("permissionsCatName", "Sub Category") &&
      <ListItemButton onClick={() => setOpenSubCategory(!openSubCategory)}>
        <ListItemIcon>
          <CategoryIcon />
        </ListItemIcon>
        <ListItemText primary="Sub Category" />
        {openSubCategory ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openSubCategory} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/subCategory/subCategoryAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Sub Category Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Sub Category" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/subCategory/subCategoryList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Sub Category List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Sub Category List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* PRODUCT */}
    {Checkpermissions("permissionsCatName", "Product") &&
      <ListItemButton onClick={() => setOpenProduct(!openProduct)}>
        <ListItemIcon>
          <InventoryIcon />
        </ListItemIcon>
        <ListItemText primary="Product" />
        {openProduct ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openProduct} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Product/addProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Product" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Product/listProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Product List" />
            </ListItemButton>}
        </NavLink>
        {/* <NavLink to="/inventory/Product/storeProductList">
          {Checkpermissions("permissionsSubCatName", "Store Product List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Store Product List" />
            </ListItemButton>}
        </NavLink> */}
        {/* <NavLink to="/inventory/product/ProductBalance">
          {Checkpermissions("permissionsSubCatName", "Store Product Difference Report") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Product Difference Report" />
            </ListItemButton>}
        </NavLink> */}
        <NavLink to="/inventory/product/uploadProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product Upload") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <UploadFileIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Product" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* CUSTOMER */}
    {Checkpermissions("permissionsCatName", "Customer") &&
      <ListItemButton onClick={() => setOpenCustomer(!openCustomer)}>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Customer" />
        {openCustomer ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCustomer} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Customer/addCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Customer" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Customer/listCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Customer List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* Area */}
    {Checkpermissions("permissionsCatName", "Area") && (
      <ListItemButton onClick={() => setOpenArea(!openArea)}>
        <ListItemIcon>
          <DiscountIcon />
        </ListItemIcon>
        <ListItemText primary="Area" />
        {openArea ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    )}
    <Collapse in={openArea} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Area/addArea" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Area Add") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Area" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/Area/listArea" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Area List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Area List" />
            </ListItemButton>
          )}
        </NavLink>
      </List>
    </Collapse>

    {/* Shop */}
    {Checkpermissions("permissionsCatName", "Shop") && (
      <ListItemButton onClick={() => setOpenShop(!openShop)}>
        <ListItemIcon>
          <StorefrontIcon />
        </ListItemIcon>
        <ListItemText primary="Shop" />
        {openShop ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    )}
    <Collapse in={openShop} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/shop/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Shop Add") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Shop" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/shops" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Shop List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Shop List" />
            </ListItemButton>
          )}
        </NavLink>
      </List>
    </Collapse>

    {/* VENDOR */}
    {Checkpermissions("permissionsCatName", "Vendor") &&
      <ListItemButton onClick={() => setOpenVendor(!openVendor)}>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Vendor" />
        {openVendor ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openVendor} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Vendor/addVendor" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Vendor" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Vendor/listVendor" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Vendor List" />
            </ListItemButton>}</NavLink>
      </List>
    </Collapse>

    {/* OrderBooking */}
    {Checkpermissions("permissionsCatName", "Order Booking") && (
      <ListItemButton onClick={() => setOpenOrderBooking(!openOrderBooking)}>
        <ListItemIcon>
          <AddShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="Order Booking" />
        {openOrderBooking ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    )}
    <Collapse in={openOrderBooking} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/order-bookings/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Order Booking Add") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Order Booking" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/order-bookings/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Order Booking List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Order Booking List" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/order-bookings/reports" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Order Booking List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <SummarizeIcon />
              </ListItemIcon>
              <ListItemText primary="Booking Reports" />
            </ListItemButton>
          )}
        </NavLink>
      </List>
    </Collapse>

    {/* PAYMENT */}
    {Checkpermissions("permissionsCatName", "Payment Receving") && (
      <ListItemButton onClick={() => setPaymentReceiving(!openPaymentReceiving)}>
        <ListItemIcon>
          <PaymentsIcon />
        </ListItemIcon>
        <ListItemText primary="Payment Receving" />
        {openPaymentReceiving ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    )}
    <Collapse in={openPaymentReceiving} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/payment-recevings/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Payment Receving Add") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Payment Receving" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/payment-recevings/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Payment Receving List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Payment Receving List" />
            </ListItemButton>
          )}
        </NavLink>
        <NavLink to="/inventory/payment-report" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Payment Receving List") && (
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Payment Report" />
            </ListItemButton>
          )}
        </NavLink>
      </List>
    </Collapse>

    {/* PURCHASE ORDER */}
    {Checkpermissions("permissionsCatName", "Purchase Order") &&
      <ListItemButton onClick={() => setOpenPurchase(!openPurchase)}>
        <ListItemIcon>
          <ShoppingBasketIcon />
        </ListItemIcon>
        <ListItemText primary="Purchase Order" />
        {openPurchase ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    }
    <Collapse in={openPurchase} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/purchase/PurchaseOrderAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Purchase Order Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Purchase Order" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/purchase/PurchaseOrderList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Purchase Order List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Purchase Order List" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* IGP */}
    {Checkpermissions("permissionsCatName", "IGP") &&
      <ListItemButton onClick={() => setIgp(!igp)}>
        <ListItemIcon>
          <TransferWithinAStationIcon />
        </ListItemIcon>
        <ListItemText primary="IGP" />
        {igp ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    }
    <Collapse in={igp} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/igp/IgpAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "IGP Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="ADD IGP" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/igp/IgpList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "IGP List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="IGP List" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* DEMAND */}
    {Checkpermissions("permissionsCatName", "Demand") &&
      <ListItemButton onClick={() => setOpenDemand(!openDemand)}>
        <ListItemIcon>
          <VolunteerActivismIcon />
        </ListItemIcon>
        <ListItemText primary="Demand" />
        {openDemand ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openDemand} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/demand/DemandAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Demand Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Demand" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/demand/DemandList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Demand List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Demand List" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* ISSUANCE */}
    {Checkpermissions("permissionsCatName", "Issuance") &&
      <ListItemButton onClick={() => setOpenissuance(!openIssuance)}>
        <ListItemIcon>
          <ArrowCircleUpIcon />
        </ListItemIcon>
        <ListItemText primary="Issuance" />
        {openIssuance ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openIssuance} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/issuance/addIssuance" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Issuance Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Issuance" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/Issuance/IssuanceDetail" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Issuance List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Issuance List" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/Issuance/IssuanceById" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Issuance Report With Id") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Issuance Report By Id" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/Issuance/IssuanceWithDate" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Issuance Report With Dates") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText primary="Issuance Report By Date" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* RECEVING */}
    {Checkpermissions("permissionsCatName", "Receiving") &&
      <ListItemButton onClick={() => setOpenReciving(!openReciving)}>
        <ListItemIcon>
          <ArrowCircleDownIcon />
        </ListItemIcon>
        <ListItemText primary="Receiving" />
        {openReciving ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openReciving} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/receiving/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Receiving Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Receiving" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/receiving/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Receiving List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Receiving List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/receiving/report" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Receiving Report") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText primary="Receiving Report" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/receiving/return/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Receiving Return") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Receiving Return" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/receiving/return/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Receiving Return List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Receiving Return List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* INVENTORY LEDGER */}
    {Checkpermissions("permissionsCatName", "Inventory Ledger") &&
      <NavLink to="/inventory/ledger" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <SummarizeIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Inventory Ledger" />
        </ListItemButton>
      </NavLink>}

  </List>

  // { MASTERCONTROL LIST }
  let MasterControlList = <List>
    {/* Recipe */}
    {Checkpermissions("permissionsCatName", "Recipe") &&
      <ListItemButton onClick={() => setOpenRecipe(!openRecipe)}>
        <ListItemIcon>
          <RamenDiningIcon />
        </ListItemIcon>
        <ListItemText primary="Recipe" />
        {openRecipe ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openRecipe} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Recipe/addRecipe" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Recipe Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Recipe" />
            </ListItemButton>}
        </NavLink>
        {/* "/inventory/catagory/listcatagory" */}
        <NavLink to="/inventory/Recipe/listRecipe" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Recipe List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Recipe List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* Flavour */}
    {Checkpermissions("permissionsCatName", "Colour") &&
      <ListItemButton onClick={() => setOpenFlavour(!openFlavour)}>
        <ListItemIcon>
          <LocalPizzaIcon />
        </ListItemIcon>
        <ListItemText primary="Colour" />
        {openFlavour ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openFlavour} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Colour/addColour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Colour Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Colour" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Colour/listColour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Colour List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Colour List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* BRAND */}
    {Checkpermissions("permissionsCatName", "Brand") &&
      <ListItemButton onClick={() => setOpenBrand(!openBrand)}>
        <ListItemIcon>
          <LabelIcon />
        </ListItemIcon>
        <ListItemText primary="Brand" />
        {openBrand ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openBrand} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/brand/addBrand" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Brand Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Brand" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/brand/brandList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Brand List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Brand List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* Size */}
    {Checkpermissions("permissionsCatName", "Size") &&
      <ListItemButton onClick={() => setOpenSize(!openSize)}>
        <ListItemIcon>
          <StraightenIcon />
        </ListItemIcon>
        <ListItemText primary="Size" />
        {openSize ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openSize} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Size/addSize" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Size Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Size" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Size/listSize" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Size List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Size List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* Generate Barcode */}
    {Checkpermissions("permissionsCatName", "Barcode") &&
      <ListItemButton onClick={() => setGenerateBarCode(!generateBarcode)}>
        <ListItemIcon>
          <StraightenIcon />
        </ListItemIcon>
        <ListItemText primary="Barcode" />
        {generateBarcode ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={generateBarcode} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/barcode/generateBarcode" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Generate Barcode") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Generate Barcode" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* Deal */}
    {Checkpermissions("permissionsCatName", "Deal") &&
      <ListItemButton onClick={() => setOpenDeal(!openDeal)}>
        <ListItemIcon>
          <RamenDiningIcon />
        </ListItemIcon>
        <ListItemText primary="Deal" />
        {openDeal ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openDeal} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/deal/addDeal" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Deal Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Deal" />
            </ListItemButton>
          }
        </NavLink>
        {/* "/inventory/catagory/listcatagory" */}
        <NavLink to="/inventory/deal/dealList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Deal List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Deal List" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>

    {/* Deal */}
    {Checkpermissions("permissionsCatName", "Expense Type") &&
      <ListItemButton onClick={() => setOpenExpenseType(!openExpenseType)}>
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="Expense Type" />
        {openExpenseType ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openExpenseType} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/expense/expenseType" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Expense Type Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Expense Type Add" />
            </ListItemButton>
          }
        </NavLink>
        <NavLink to="/inventory/expense/expenseTypeList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Expense Type List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Expense Type List" />
            </ListItemButton>
          }
        </NavLink>
      </List>
    </Collapse>


    {/* Hall */}
    {/* {Checkpermissions("permissionsCatName", "Hall") &&
      <ListItemButton onClick={() => setOpenhall(!openhall)}>
        <ListItemIcon>
          <AddBusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Hall" />
        {openhall ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openhall} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Hall/addHall">
          {Checkpermissions("permissionsSubCatName", "Hall Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Hall" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Hall/listHall">
          {Checkpermissions("permissionsSubCatName", "Hall List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Hall List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse> */}

    {/* Table */}
    {/* {Checkpermissions("permissionsCatName", "Table") &&
      <ListItemButton onClick={() => setOpenTable(!openTable)}>
        <ListItemIcon>
          <TableRestaurantIcon />
        </ListItemIcon>
        <ListItemText primary="Rack" />
        {openTable ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openTable} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Table/addTable">
          {Checkpermissions("permissionsSubCatName", "Table Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Rack" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Table/uploadTable">
          {Checkpermissions("permissionsSubCatName", "Table Upload") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Rack" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Table/listTable">
          {Checkpermissions("permissionsSubCatName", "Table List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Rack List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse> */}

    {/*Coupon*/}
    {Checkpermissions("permissionsCatName", "Coupon") &&
      <ListItemButton onClick={() => setOpenCoupon(!openCoupon)}>
        <ListItemIcon>
          <DiscountIcon />
        </ListItemIcon>
        <ListItemText primary="Coupon" />
        {openCoupon ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCoupon} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Coupon/addCoupon" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Coupon Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Coupon" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Coupon/listCoupon" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Coupon List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <LineWeightIcon />
              </ListItemIcon>
              <ListItemText primary="Coupon List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* UOM */}
    {Checkpermissions("permissionsCatName", "UOM") &&
      <ListItemButton onClick={() => setOpenUom(!openUom)}>
        <ListItemIcon>
          <ScaleIcon />
        </ListItemIcon>
        <ListItemText primary="Uom" />
        {openUom ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openUom} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/uom/adduom" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "UOM Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Uom" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/uom/listUom" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "UOM List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Uom List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* {Checkpermissions("permissionsCatName", "UOM") &&
      <NavLink to="/inventory/uomlist" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <AutoStoriesIcon />
          </ListItemIcon>
          <ListItemText primary="UOM List" />
        </ListItemButton>
      </NavLink>} */}

  </List>

  // { SETTING LIST }
  let SettingList = <List>
    {/* COMPANY */}
    {Checkpermissions("permissionsCatName", "Company") &&
      <ListItemButton onClick={() => setOpenRestaurant(!openRestaurant)}>
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Open New Company" />
        {openRestaurant ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openRestaurant} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/setting/Company/addCompany" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Company Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Company" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/setting/Company/listCompany" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Company List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Company List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* USER */}
    {Checkpermissions("permissionsCatName", "User") &&
      <ListItemButton onClick={() => setOpenUser(!openUser)}>
        <ListItemIcon>
          <PersonAddAlt1Icon />
        </ListItemIcon>
        <ListItemText primary="User" />
        {openUser ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openUser} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/setting/addUser" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "User Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New User" />
            </ListItemButton>
          }
        </NavLink>
        {Checkpermissions("permissionsSubCatName", "User List") &&
          <NavLink to="/setting/listUser" style={({ isActive }) => navLinkStyles(isActive)}>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="User List" />
            </ListItemButton>
          </NavLink>}
      </List>
    </Collapse>

    {/* ACCOUNT INTEGRATION */}
    {Checkpermissions("permissionsCatName", "Accounts Integration") &&
      <NavLink to="/setting/accounts-integration" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <MeetingRoomIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Accounts Integration" />
        </ListItemButton>
      </NavLink>}

    {/* DAY OPEN */}
    {Checkpermissions("permissionsCatName", "Day Open") &&
      <NavLink to="/setting/opening" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <MeetingRoomIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Day Open" />
        </ListItemButton>
      </NavLink>}
    {/* DAY CLOSE */}
    {Checkpermissions("permissionsCatName", "Day Close") &&
      <NavLink to="/setting/closing" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <DoorSlidingIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Day Close" />
        </ListItemButton>
      </NavLink>}
    {/* DAY OPEN RECORDS */}
    {Checkpermissions("permissionsCatName", "DayOpen Record") &&
      <NavLink to="/setting/dayOpen_record" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Day Open Record" />
        </ListItemButton>
      </NavLink>}
    {/* PERMISSIONS */}
    {Checkpermissions("permissionsCatName", "Permission") &&
      <NavLink to="/setting/permission" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <VerifiedUserIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Permissions" />
        </ListItemButton>
      </NavLink>
    }
    {/* BACKUP */}
    {Checkpermissions("permissionsCatName", "BackUp") &&
      <NavLink to="/setting/BackUp" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <BackupIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Backup" />
        </ListItemButton>
      </NavLink>
    }

    {/* LOGIN HISTORY */}
    {Checkpermissions("permissionsCatName", "Login History") &&
      <NavLink to="/setting/loginHistory" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <HistoryIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Login History" />
        </ListItemButton>
      </NavLink>
    }

    {/* WHATS APP */}
    {/* {Checkpermissions("permissionsCatName", "Whats App Ingegration") &&
      <NavLink to="/setting/whatsapp" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <WhatsAppIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="WhatsApp SMS" />
        </ListItemButton>
      </NavLink>
    } */}


  </List>

  // { PRODUCTION LIST }
  let ProductionList = <List>

    {/* MASTER SETTING */}
    {Checkpermissions("permissionsCatName", "Category") &&
      <ListItemButton onClick={() => setOpenCategory(!openCategory)}>
        <ListItemIcon>
          <SettingsSuggestIcon />
        </ListItemIcon>
        <ListItemText primary="Master Setting" />
        {openCategory ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCategory} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/catagory/addcatagory" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Category" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/catagory/listcatagory" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Category List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/subCategory/subCategoryAdd" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Sub Category Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Sub Category" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/subCategory/subCategoryList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Sub Category List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Sub Category List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Size/addSize" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Size Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Size" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Size/listSize" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Size List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Sizes List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/uom/adduom" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "UOM Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Uom" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/uom/listUom" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "UOM List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Uom's List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Colour/addColour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Colour Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Colour" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Colour/listColour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Colour List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Colours List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Customer/addCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Customer" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Customer/listCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Customers List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/brand/addBrand" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Brand Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Brand" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/brand/brandList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Brand List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Brands List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Vendor/addVendor" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Vendor" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Vendor/listVendor" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Vendors List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Employee/AddProductionEmployee" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Employee" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Employee/ViewProductionEmployee" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Employees List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/process/AddProcess" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Process" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/process/ViewProcess" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Process List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Hall/addHall" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Hall Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Hall" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Hall/listHall" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Hall List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Halls List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Machine/AddMachine" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Hall Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Machine" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Machine/ViewMachine" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Hall List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Machines List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* ARTICLE */}
    {Checkpermissions("permissionsCatName", "Vendor") &&
      <ListItemButton onClick={() => setArticle(!article)}>
        <ListItemIcon>
          <ArticleIcon />
        </ListItemIcon>
        <ListItemText primary="Article" />
        {article ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={article} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/production/Article/AddArticle" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Article" />
            </ListItemButton>}
        </NavLink>
        {/* <NavLink to="/production/Article/AddArticleVariation" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Article Variation" />
            </ListItemButton>}
        </NavLink> */}
        <NavLink to="/production/Article/AddArticleRecipe" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Article Recipe" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Article/ViewArticle" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Articles List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/production/Article/ArticleFilter" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Vendor List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <TuneIcon />
              </ListItemIcon>
              <ListItemText primary="Articles Filter" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* ORDER CREATION */}
    <ListItemButton onClick={() => setOrderCreation(!orderCreation)}>
      <ListItemIcon>
        <BusinessIcon />
      </ListItemIcon>
      <ListItemText primary="Orders" />
      {orderCreation ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={orderCreation} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/production/OrderCreation/AddOrderCreation" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="New Order" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/OrderCreation/ListOrderCreation" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="Orders List" />
          </ListItemButton>
        </NavLink>
      </List>
    </Collapse>

    {/* COST CONTROL */}
    <ListItemButton onClick={() => setCostControl(!costControl)}>
      <ListItemIcon>
        <RequestQuoteIcon />
      </ListItemIcon>
      <ListItemText primary="Order Planing" />
      {costControl ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={costControl} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/production/CostControl/MaterialRequired" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="Material Requirment" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/CostControl/ProcessRequired" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="Labour Cost" />
          </ListItemButton>
        </NavLink>
        {/* <NavLink to="/production/CostControl/AdminCostRequired" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="Over Heads Cost" />
          </ListItemButton>
        </NavLink> */}
      </List>
    </Collapse>

    {/* PRODUCTION ISSUANCE */}
    <ListItemButton onClick={() => setProductionIssuance(!productionIssuance)}>
      <ListItemIcon>
        <SendIcon />
      </ListItemIcon>
      <ListItemText primary="Issuance" />
      {productionIssuance ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={productionIssuance} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/production/ProductionIssuance/AddProductionIssuance" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="Add Issuance" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/ProductionIssuance/ViewProductionIssuance" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="Issuance List" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/ProductionIssuance/ProductionIssuanceReport" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Issuance Report" />
          </ListItemButton>
        </NavLink>
      </List>
    </Collapse>

    {/* PRODUCTION RECEIVING */}
    <ListItemButton onClick={() => setProductionReceiving(!productionReceiving)}>
      <ListItemIcon>
        <AssignmentReturnedIcon />
      </ListItemIcon>
      <ListItemText primary="Receiving" />
      {productionReceiving ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={productionReceiving} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/production/ProductionReceiving/AddProductionReceiving" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary="New Receiving" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/ProductionReceiving/ViewProductionReceiving" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="Receiving List" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/production/ProductionReceiving/ProductionReceivingReport" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Receiving Report" />
          </ListItemButton>
        </NavLink>
      </List>
    </Collapse>





  </List>

  // { HR LIST }
  let HRList = <List>
    {/* DIVISION  */}
    {Checkpermissions("permissionsCatName", "Division") &&
      <ListItemButton onClick={() => setDivision(!division)}>
        <ListItemIcon>
          <AlignVerticalBottomIcon />
        </ListItemIcon>
        <ListItemText primary="Division" />
        {division ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={division} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/division/AddDivision" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Division") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Division" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/division/ViewDivision" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Division List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Division List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* DEPARTMENT  */}
    {Checkpermissions("permissionsCatName", "Department") &&
      <ListItemButton onClick={() => setDepartment(!department)}>
        <ListItemIcon>
          <ApartmentIcon />
        </ListItemIcon>
        <ListItemText primary="Department" />
        {department ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={department} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/department/AddDepartment" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Department") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Department" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/department/ViewDepartment" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Department List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Department List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* DESIGNATION  */}
    {Checkpermissions("permissionsCatName", "Designation") &&
      <ListItemButton onClick={() => setDesignation(!designation)}>
        <ListItemIcon>
          <CompareArrowsIcon />
        </ListItemIcon>
        <ListItemText primary="Designation" />
        {designation ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={designation} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/designation/AddDesignation" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Designation") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Designation" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/designation/ViewDesignation" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Designation List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Designation List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* SHIFT-CONTROL */}
    {Checkpermissions("permissionsCatName", "ShiftControl") &&
      <ListItemButton onClick={() => setShiftControl(!shiftControl)}>
        <ListItemIcon>
          <RepartitionIcon />
        </ListItemIcon>
        <ListItemText primary="ShiftControl" />
        {shiftControl ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={shiftControl} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/shiftControl/AddShiftControl" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add ShiftControl") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add ShiftControl" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/shiftControl/ViewShiftControl" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "ShiftControl List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="ShiftControl List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* EMPLOYEE-TYPE */}
    {Checkpermissions("permissionsCatName", "EmployeeType") &&
      <ListItemButton onClick={() => setEmployeeType(!employeeType)}>
        <ListItemIcon>
          <BadgeIcon />
        </ListItemIcon>
        <ListItemText primary="EmployeeType" />
        {employeeType ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={employeeType} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/employeeType/AddEmployeeType" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add EmployeeType") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add EmployeeType" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/employeeType/ViewEmployeeType" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "EmployeeType List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="EmployeeType List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* EMPLOYEE */}
    {Checkpermissions("permissionsCatName", "Employee") &&
      <ListItemButton onClick={() => setEmployee(!employee)}>
        <ListItemIcon>
          <PersonAddAltIcon />
        </ListItemIcon>
        <ListItemText primary="Employee" />
        {employee ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={employee} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/employee/AddEmployee" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Employee") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Employee" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/employee/ViewEmployee" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Employee List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Employee List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* SALARY */}
    {Checkpermissions("permissionsCatName", "Salary") &&
      <ListItemButton onClick={() => setAddSalary(!addSalary)}>
        <ListItemIcon>
          <PaidIcon />
        </ListItemIcon>
        <ListItemText primary="Salary" />
        {addSalary ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={addSalary} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/salary/AddSalary" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Salary") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Salary" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/salary/EditSalaryWithEmpID" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Edit Salary") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Edit Salary" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* INCREMENT */}
    {Checkpermissions("permissionsCatName", "Increment") &&
      <ListItemButton onClick={() => setAddIncrement(!addIncrement)}>
        <ListItemIcon>
          <ImportExportIcon />
        </ListItemIcon>
        <ListItemText primary="Increment" />
        {addIncrement ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={addIncrement} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/increment/AddIncrement" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Increment") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Increment" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/increment/IncrementList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Increment List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Increment List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* MASTERCONTROL HR */}
    <NavLink to="/hr/masterControl/AddMasterControlHR" style={({ isActive }) => navLinkStyles(isActive)}>
      {Checkpermissions("permissionsCatName", "Master Control HR") &&
        <ListItemButton>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Master Control" />
        </ListItemButton>}
    </NavLink>


    {/* SHORT-TERM */}
    {Checkpermissions("permissionsCatName", "Short-Term Advance") &&
      <ListItemButton onClick={() => setSTAdvance(!STAdvance)}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary="Short-Term Advance" />
        {STAdvance ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={STAdvance} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/shortTerm/STPayment" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "ST Pay Advance") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Pay Advance" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/shortTerm/STReciving" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "ST Receive Advance") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Receive Advance" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/shortTerm/STList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "ST Advance List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Advance List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/shortTerm/STLedger" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "ST Ledger") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Ledger" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* LONG-TERM */}
    {Checkpermissions("permissionsCatName", "Long-Term Advance") &&
      <ListItemButton onClick={() => setLTAdvance(!LTAdvance)}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary="Long-Term Advance" />
        {LTAdvance ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={LTAdvance} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/longTerm/LTPayment" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "LT Pay Advance") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Pay Advance" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/longTerm/LTReciving" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "LT Receive Advance") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Receive Advance" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/longTerm/LTList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "LT Advance List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Advance List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/longTerm/LTLedger" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "LT Ledger") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Ledger" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* FINE & PENALTIES */}
    {Checkpermissions("permissionsCatName", "Fine & Penalties") &&
      <ListItemButton onClick={() => setFine(!fine)}>
        <ListItemIcon>
          <RemoveCircleOutlineIcon />
        </ListItemIcon>
        <ListItemText primary="Fine & Penalties" />
        {fine ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={fine} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/fine/AddFineAndPenalty" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Add Fine & Penalties") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Fine & Penalties" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/fine/FineAndPenaltyList" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Fine & Penalties List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Fine & Penalties List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* ATTENDANCE */}
    {Checkpermissions("permissionsCatName", "Attendance") &&
      <ListItemButton onClick={() => setAttendance(!attendance)}>
        <ListItemIcon>
          <EventNoteIcon />
        </ListItemIcon>
        <ListItemText primary="Attendance" />
        {attendance ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={attendance} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/attendance/AttendanceUpload" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Upload Attendance") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <UploadFileIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Attendance" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/attendance/AttendanceView" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Attendance List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Attendance List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* GENRATE SALARY */}
    {Checkpermissions("permissionsCatName", "Generate Salary") &&
      <ListItemButton onClick={() => setSalary(!salary)}>
        <ListItemIcon>
          <CurrencyExchangeIcon />
        </ListItemIcon>
        <ListItemText primary="Generate Salary" />
        {salary ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={salary} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/hr/salary/GenerateSalary" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Generate Salary") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <SimCardDownloadIcon />
              </ListItemIcon>
              <ListItemText primary="Generate Salary" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/hr/salary/SalaryHistory" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsCatName", "Salary History") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Salary History" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


  </List>

  // { CRM LIST }
  let CRMList = <List>

    {/* PRODUCT  */}
    {Checkpermissions("permissionsCatName", "Service") &&
      <ListItemButton onClick={() => setOpenProduct(!openProduct)}>
        <ListItemIcon>
          <InventoryIcon />
        </ListItemIcon>
        <ListItemText primary="Service" />
        {openProduct ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openProduct} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/crm/product/AddProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Service") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Service" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/product/ViewProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Service List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Service List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* CUSTOMER  */}
    {Checkpermissions("permissionsCatName", "Client") &&
      <ListItemButton onClick={() => setOpenCustomer(!openCustomer)}>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Client" />
        {openCustomer ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCustomer} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/crm/customer/AddCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Client") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Client" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/customer/ViewCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Client List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Client List" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/customer/UpdateCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Comment") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddCommentIcon />
              </ListItemIcon>
              <ListItemText primary="Add Comment" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/customer/UploadCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Upload Client") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <UploadFileIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Client" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* TEAM MEMBER  */}
    {Checkpermissions("permissionsCatName", "Team Member") &&
      <ListItemButton onClick={() => setOpenTeamMember(!openTeamMember)}>
        <ListItemIcon>
          <PeopleAltIcon />
        </ListItemIcon>
        <ListItemText primary="Team Member" />
        {openTeamMember ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openTeamMember} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/crm/teamMember/AddTeamMember" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Team Member") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Team Member" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/teamMember/ViewTeamMember" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "View Team Member") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Team Member" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


    {/* JOB  */}
    {Checkpermissions("permissionsCatName", "Job") &&
      <ListItemButton onClick={() => setOpenJob(!openJob)}>
        <ListItemIcon>
          <WorkIcon />
        </ListItemIcon>
        <ListItemText primary="Job" />
        {openJob ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openJob} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/crm/job/Addjob" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Job") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Job" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/job/ViewJob" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "View Job") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Job" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/crm/job/JobReport" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <FindInPageIcon />
            </ListItemIcon>
            <ListItemText primary="Job Report" />
          </ListItemButton>
        </NavLink>
        <NavLink to="/crm/job/DocumentType" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Document Type") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <InsertDriveFileIcon />
              </ListItemIcon>
              <ListItemText primary="Document Type" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


  </List>

  // { ACCOUNTS MODULE LIST }
  let AccountsModuleList = <List>

    {/* DASHBOARD  */}
    <NavLink to="/accountsModule/AccountsDashboard" style={({ isActive }) => navLinkStyles(isActive)}>
      <ListItemButton>
        <ListItemIcon>
          <TrendingUpIcon />
        </ListItemIcon>
        <ListItemText style={{ color: 'black' }} primary="Dashboard" />
      </ListItemButton>
    </NavLink>

    {/* INVOICE  */}
    {Checkpermissions("permissionsCatName", "Invoice") &&
      <ListItemButton onClick={() => setOpenInvoice(!openInvoice)}>
        <ListItemIcon>
          <RequestPageIcon />
        </ListItemIcon>
        <ListItemText primary="Invoice" />
        {openInvoice ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openInvoice} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/accountsModule/Invoice/AddInvoice" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Invoice") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Invoice" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/Invoice/ViewInvoice" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Invoice Detail") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Invoice" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* LEVEL 1  */}
    {Checkpermissions("permissionsCatName", "Level One") &&
      <NavLink to="/accountsModule/levelOne/ViewLevelOne" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Level 1" />
        </ListItemButton>
      </NavLink>}

    {/* LEVEL 2  */}
    {Checkpermissions("permissionsCatName", "Level Two") &&
      <ListItemButton onClick={() => setOpenLevelTwo(!openLevelTwo)}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Level 2" />
        {openLevelTwo ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openLevelTwo} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/accountsModule/levelTwo/AddLevelTwo" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Level Two") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Level 2" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/levelTwo/ViewLevelTwo" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Level Two Detail") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Level 2" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* LEVEL 3  */}
    {Checkpermissions("permissionsCatName", "Level Three") &&
      <ListItemButton onClick={() => setOpenLevelThree(!openLevelThree)}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Level 3" />
        {openLevelThree ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openLevelThree} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/accountsModule/levelThree/AddLevelThree" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Level Three") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Level 3" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/levelThree/ViewLevelThree" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Level Three Detail") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Level 3" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/levelThree/UploadLevelThree" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Level Three Upload") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <UploadFileIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Level 3" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* LEVEL 4  */}
    {Checkpermissions("permissionsCatName", "Level Four") &&
      <ListItemButton onClick={() => setOpenLevelFour(!openLevelFour)}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Level 4" />
        {openLevelFour ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openLevelFour} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/accountsModule/levelFour/AddLevelFour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Level Four") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Level 4" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/levelFour/ViewLevelFour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Level Four Detail") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="View Level 4" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/levelFour/UploadLevelFour" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Level Four Upload") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <UploadFileIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Level 4" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* VOUCHER  */}
    {Checkpermissions("permissionsCatName", "Voucher") &&
      <ListItemButton onClick={() => setOpenVoucher(!openVoucher)}>
        <ListItemIcon>
          <NoteAddIcon />
        </ListItemIcon>
        <ListItemText primary="Vouchers" />
        {openVoucher ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openVoucher} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/accountsModule/Voucher/CashPaymentVoucher" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "CPV") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Cash Payment" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/Voucher/CashReceiptVoucher" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "CRV") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Cash Receipt" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/Voucher/BankPaymentVoucher" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "BPV") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Bank Payment" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/Voucher/BankReceiptVoucher" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "BRV") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Bank Receipt" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/accountsModule/Voucher/JournalVoucher" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "JV") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Journal" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* VOUCHER VERIFICATION */}
    {Checkpermissions("permissionsCatName", "Voucher Verification") &&
      <NavLink to="/accountsModule/Voucher/VoucherVerification" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <VerifiedUserIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Voucher Verification" />
        </ListItemButton>
      </NavLink>}

    {/* VOUCHER SEARCH */}
    {Checkpermissions("permissionsCatName", "Voucher Search") &&
      <NavLink to="/accountsModule/Voucher/VoucherSearch" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <PlagiarismIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Voucher Search" />
        </ListItemButton>
      </NavLink>}

    {/* LEDGER */}
    {Checkpermissions("permissionsCatName", "Accounts Ledger") &&
      <NavLink to="/accountsModule/Ledger" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Accounts Ledger" />
        </ListItemButton>
      </NavLink>}

    {/* TRAIL BALANCE */}
    {Checkpermissions("permissionsCatName", "Trail Balance") &&
      <NavLink to="/accountsModule/TrailBalance" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <FactCheckIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Trail Balance" />
        </ListItemButton>
      </NavLink>}

    {/* CHART OF ACCOUNT */}
    {Checkpermissions("permissionsCatName", "Chat Of Account") &&
      <NavLink to="/accountsModule/ViewChartOfAccount" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <InsertChartIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Chat Of Account" />
        </ListItemButton>
      </NavLink>}

    {/* AGING REPORT */}
    {Checkpermissions("permissionsCatName", "Aging Report") &&
      <NavLink to="/accountsModule/ViewAging" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Aging Report" />
        </ListItemButton>
      </NavLink>}

    {/* CASH BOOK REPORT */}
    {Checkpermissions("permissionsCatName", "Cash Book Report") &&
      <NavLink to="/accountsModule/ViewCashBook" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <RequestQuoteIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Cash Book" />
        </ListItemButton>
      </NavLink>}



  </List>

  // { CONSTRUCTION MODULE }
  let ConstructionModule = <List>

    <NavLink to="/contruction/order/dashboard" style={({ isActive }) => navLinkStyles(isActive)}>
      <ListItemButton>
        <ListItemIcon>
          <TrendingUpIcon />
        </ListItemIcon>
        <ListItemText style={{ color: 'black' }} primary={t("ConstructionOrderDashboard")} />
      </ListItemButton>
    </NavLink>

    {/* CATEGORY */}
    {Checkpermissions("permissionsCatName", "Category") &&
      <ListItemButton onClick={() => setOpenCategory(!openCategory)}>
        <ListItemIcon>
          <CategoryIcon />
        </ListItemIcon>
        <ListItemText primary={t("Category")} />
        {openCategory ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCategory} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/contruction/catagory/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary={t("AddCategory")} />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/contruction/catagory/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Category List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("CategoryList")} />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* PRODUCT */}
    {Checkpermissions("permissionsCatName", "Product") &&
      <ListItemButton onClick={() => setOpenProduct(!openProduct)}>
        <ListItemIcon>
          <InventoryIcon />
        </ListItemIcon>
        <ListItemText primary={t("Product")} />
        {openProduct ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openProduct} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Product/addProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary={t("AddProduct")} />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Product/listProduct" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("ProductList")} />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* CUSTOMER */}
    {Checkpermissions("permissionsCatName", "Customer") &&
      <ListItemButton onClick={() => setOpenCustomer(!openCustomer)}>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary={t("Customer")} />
        {openCustomer ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openCustomer} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/inventory/Customer/addCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary={t("AddCustomer")} />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/inventory/Customer/listCustomer" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Customer List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("CustomerList")} />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* CONSTRUCTION ORDER */}
    {Checkpermissions("permissionsCatName", "Construction Order") &&
      <ListItemButton onClick={() => setOpenConstructionOrder(!openConstructionOrder)}>
        <ListItemIcon>
          <AddShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary={t("ConstructionOrder")} />
        {openConstructionOrder ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openConstructionOrder} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/contruction/order/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Construction Order") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary={t("AddConstructionOrder")} />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/contruction/order/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Construction Order List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("ConstructionOrderList")} />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/contruction/order/payment/new" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText primary={t("AddOrderPayment")} />
          </ListItemButton>
        </NavLink>
        <NavLink to="/contruction/order/payment/list" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary={t("OrderPaymentList")} />
          </ListItemButton>
        </NavLink>
        <NavLink to="/contruction/order/payment/ledger" style={({ isActive }) => navLinkStyles(isActive)}>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <HistoryIcon />
            </ListItemIcon>
            <ListItemText primary={t("OrderPaymentLedger")} />
          </ListItemButton>
        </NavLink>
      </List>
    </Collapse>

    {/* CONSTRUCTION EXPENSE */}
    {Checkpermissions("permissionsCatName", "Expense") &&
      <ListItemButton onClick={() => setOpenConstructionExpense(!openConstructionExpense)}>
        <ListItemIcon>
          <CurrencyExchangeIcon />
        </ListItemIcon>
        <ListItemText primary={t("Expense")} />
        {openConstructionExpense ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openConstructionExpense} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/contruction/expense/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Add Expense") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary={t("AddExpense")} />
            </ListItemButton>}
        </NavLink>
        {/* <NavLink to="/contruction/expense/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Expense List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("ExpenseList")} />
            </ListItemButton>}
        </NavLink> */}
        <NavLink to="/contruction/expense/report" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Expense Report") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("ExpenseReport")} />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>


  </List>

  // { FBR INVOICE MODULE }
  let FBRInvoiceModule = <List>
    {Checkpermissions("permissionsCatName", "Company") &&
      <ListItemButton onClick={() => setOpenFBRCompany(!openFBRCompany)}>
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Company" />
        {openFBRCompany ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openFBRCompany} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/fbr/company/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Company Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="Add Company" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/fbr/company/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Company List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Company List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* HS CODE */}
    {Checkpermissions("permissionsSubCatName", "HS Code List") &&
      <NavLink to="/fbr/hscode/list" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="HS Code List" />
        </ListItemButton>
      </NavLink>}

    {/* HS CODE */}
    {Checkpermissions("permissionsSubCatName", "HS Code List") &&
      <NavLink to="/fbr/scenario/list" style={({ isActive }) => navLinkStyles(isActive)}>
        <ListItemButton>
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary="Scenario List" />
        </ListItemButton>
      </NavLink>}

    {/* PRODUCT */}
    {Checkpermissions("permissionsCatName", "Product") &&
      <ListItemButton onClick={() => setOpenFBRBuyer(!openFBRBuyer)}>
        <ListItemIcon>
          <InventoryIcon />
        </ListItemIcon>
        <ListItemText primary="Product" />
        {openFBRBuyer ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openFBRBuyer} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/fbr/product/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Product" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/fbr/product/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Product List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>

    {/* BUYER */}
    {Checkpermissions("permissionsCatName", "Product") &&
      <ListItemButton onClick={() => setOpenFBRProduct(!openFBRProduct)}>
        <ListItemIcon>
          <ContactsIcon />
        </ListItemIcon>
        <ListItemText primary="Buyer" />
        {openFBRProduct ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>}
    <Collapse in={openFBRProduct} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink to="/fbr/buyer/new" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product Add") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <AddBoxIcon />
              </ListItemIcon>
              <ListItemText primary="New Buyer" />
            </ListItemButton>}
        </NavLink>
        <NavLink to="/fbr/buyer/list" style={({ isActive }) => navLinkStyles(isActive)}>
          {Checkpermissions("permissionsSubCatName", "Product List") &&
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Buyer List" />
            </ListItemButton>}
        </NavLink>
      </List>
    </Collapse>



  </List>


  if (props.moduleKey === 'UserInventory' || window.localStorage.getItem('module_key') === 'user_inventory') return MasterControlList;
  else if (props.moduleKey === 'storeList' || window.localStorage.getItem('module_key') === 'storeList') return StoreList;
  else if (props.moduleKey === 'setting' || window.localStorage.getItem('module_key') === 'setting') return SettingList;
  else if (props.moduleKey === 'production' || window.localStorage.getItem('module_key') === 'production') return ProductionList;
  else if (props.moduleKey === 'hr' || window.localStorage.getItem('module_key') === 'hr') return HRList;
  else if (props.moduleKey === 'crm' || window.localStorage.getItem('module_key') === 'crm') return CRMList;
  else if (props.moduleKey === 'accountsModule' || window.localStorage.getItem('module_key') === 'accountsModule') return AccountsModuleList;
  else if (props.moduleKey === 'constructionModule' || window.localStorage.getItem('module_key') === 'constructionModule') return ConstructionModule;
  else if (props.moduleKey === 'FBRInvoiceModule' || window.localStorage.getItem('module_key') === 'FBRInvoiceModule') return FBRInvoiceModule;
  else return MasterControlList;
}; 
